export class RLCookieStore {
    constructor() {
        $.cookie.json = true;
    }

    get(key: string) {
        return $.cookie(key);
    }

    put(key: string, value: any) {
        var options: JQueryCookieOptions = {
            path: "/"
        };
        $.cookie(key, value, options);
    }

    remove(key: string) {
        $.removeCookie(key);
    }
}
